import styled from 'styled-components';
import { flexFixedSizeItem } from '../../../../themes/architecture/css-helpers/flex';

export const JackpotWidgetDefaultBox = styled.div`
    ${flexFixedSizeItem}
    margin: 1rem 1rem 3rem;
    align-self: stretch;
    max-width: 24rem;
    width: calc(100% / 6);

    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        width: calc(100% / 5);
        margin: 1rem 1.5rem 0;
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        width: calc(100% / 3);
        margin: 1rem 1.5rem 0;
    }
`;
